import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import OurAmbassadors from './pages/OurAmbassadors';
import Apply from './pages/Apply';
import ApplyMentee from './pages/ApplyMentee';
import ApplyMentor from './pages/ApplyMentor';
import JoinTheTeam from './pages/JoinTheTeam';
import Events from './pages/Events';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import StickyApplyBar from './components/StickyApplyBar';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/our-ambassadors" element={<OurAmbassadors />} />
          <Route path="/our-mentors" element={<OurAmbassadors />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply-mentee" element={<ApplyMentee />} />
          <Route path="/apply-mentor" element={<ApplyMentor />} />
          <Route path="/join-the-team" element={<JoinTheTeam />} />
          <Route path="/events" element={<Events />} />
          <Route path="/login" element={<Login />} />
        </Routes>
        <StickyApplyBar />
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
